import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'react-bootstrap';
import { contactOperations } from "./state";
import ModuleHeader from '../../components/ModuleHeader';
import TableTemplate from '../../components/TableTemplate';
import { VIEW_DELIVERY, NEW_DELIVERY } from './routes';

class Contact extends Component {

    componentDidMount() {
        this.props.fetchDefault();
    }

    viewDelivery = (row) => {
        this.props.history.push(VIEW_DELIVERY + `/${row.contactNumber}`);
    }

    addDelivery = () => {
        this.props.history.push(NEW_DELIVERY);
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"事業者→取引先連絡一覧"} />
                    <TableTemplate
                        {...this.props}
                        tableName="contact-custom-table"
                        rowButtons={[
                            {
                                onClick: this.viewDelivery,
                                icon: ['far', "edit"],
                                bsStyle: "link"
                            },
                        ]}
                    />

                    <center>
                        <Button
                            className="button-common"
                            onClick={() => this.addDelivery()}
                        >
                            新規登録
                        </Button>
                    </center>

                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tableHeader: state.contact.tableHeader,
        tableColumns: state.contact.tableColumns,
        tableList: state.contact.list
    }
};

const mapDispatchToProps = {
    fetchDefault: contactOperations.fetchDefault
};

export default connect(mapStateToProps, mapDispatchToProps)(Contact);